var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.grid},_vm._l((_vm.participants),function(p){return _c('cards-user-card',{key:p.alias,attrs:{"item":p,"display":['details']},on:{"open-modal":function($event){return _vm.$emit('close-modal')}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }